export default __webpack_public_path__ + "static/media/Shadow's Breeches of Ushering Twilight.0083ecd6.jpg";